import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MediaCategory } from '../models/media/media-category.model';
import { ViewerTemplate, ViewerTemplateDetails, SaveViewerTemplateRequest, SaveViewerTemplateResponse } from '../models/media/vet-sale-template.model';
import { SpinnerService } from '../shared-new/services/spinner.service';

@Injectable({
  providedIn: 'root'
})
export class VetSettingsService {
  public baseUrl = environment.api2BaseUrl;
  public onError: BehaviorSubject<string> = new BehaviorSubject('');

  constructor(private http: HttpClient, private spinnerService: SpinnerService) { }

  getMediaCategories(viewerTemplateId: number): Observable<MediaCategory[]> {
    const url = `${this.baseUrl}/api/VetSetting/${viewerTemplateId}/MediaCategories`;
    this.spinnerService.addRequest('getMediaCategories');
    return this.http.get<MediaCategory[]>(url, { withCredentials: false, observe: 'response' }).pipe(
      map((res: HttpResponse<MediaCategory[]>) => {
        this.spinnerService.popRequest('getMediaCategories');
        return res.body;
      }),
      catchError((error: Error) => {
        this.onError.next(error.message);
        this.spinnerService.popRequest('getMediaCategories');
        return throwError(error);
      })
    );
  }

  getViewerTemplates(): Observable<ViewerTemplate[]> {
    const url = `${this.baseUrl}/api/VetSetting/ViewerTemplates`;
    this.spinnerService.addRequest('getViewerTemplates');
    return this.http.get<ViewerTemplate[]>(url, { withCredentials: false, observe: 'response' }).pipe(
      map((res: HttpResponse<ViewerTemplate[]>) => {
        this.spinnerService.popRequest('getViewerTemplates');
        return res.body;
      }),
      catchError((error: Error) => {
        this.onError.next(error.message);
        this.spinnerService.popRequest('getViewerTemplates');
        return throwError(error);
      })
    );
  }

  getViewerTemplate(viewerTemplateId: number): Observable<ViewerTemplateDetails> {
    const url = `${this.baseUrl}/api/VetSetting/${viewerTemplateId}/ViewerTemplate`;
    this.spinnerService.addRequest('getViewerTemplate');
    return this.http.get<ViewerTemplateDetails>(url, { withCredentials: false, observe: 'response' }).pipe(
      map((res: HttpResponse<ViewerTemplateDetails>) => {
        this.spinnerService.popRequest('getViewerTemplate');
        return res.body;
      }),
      catchError((error: Error) => {
        this.onError.next(error.message);
        this.spinnerService.popRequest('getViewerTemplate');
        return throwError(error);
      })
    );
  }

  saveViewerTemplate(request: SaveViewerTemplateRequest): Observable<SaveViewerTemplateResponse> {
    const url = `${this.baseUrl}/api/VetSetting/SaveViewerTemplate`;
    this.spinnerService.addRequest('saveViewerTemplate');
    return this.http.post<SaveViewerTemplateResponse>(url, request, { withCredentials: false, observe: 'response' }).pipe(
      map((res: HttpResponse<SaveViewerTemplateResponse>) => {
        this.spinnerService.popRequest('saveViewerTemplate');
        return res.body;
      }),
      catchError((error: Error) => {
        this.onError.next(error.message);
        this.spinnerService.popRequest('saveViewerTemplate');
        return throwError(error);
      })
    );
  }
}
